/*
 * Sefer guzergahi (15.10.2026, Burak): Seferler › Siparisler sira islemleri. Sira ekranda degisir, Kaydet ile yazilir.
 * - "En uste al" (⤒) ya da ↑ ile en uste gelen siparis "Elle 1. sira" olur; kalanlar sunucunun onizlemesiyle
 *   (AmbarVoyage/GuzergahDiz) en az KM'ye gore dizilir.
 * - Orta siralardaki ↑ yalniz yer degistirir (elle duzenleme korunur).
 * - Isaret kaldirilinca (×) sefer tamamen otomatik dizilir.
 * Mesafe ve en kisa sira sunucuda hesaplanir; burada yalniz liste islemleri.
 */

export interface SiraliSiparis {
    ambarId: string
    ambarVoyageOrder: number
    elleIlkSira?: boolean
}

/** Liste sirasini 1..n olarak yazar. */
export const siraNumarala = <T extends SiraliSiparis>(liste: T[]): T[] =>
    liste.map((x, i) => ({ ...x, ambarVoyageOrder: i + 1 }));

/** Sunucunun verdigi siparis sirasini uygular; listede olmayanlar sonda eski siralariyla kalir. */
export const siraUygula = <T extends SiraliSiparis>(liste: T[], sira: string[]): T[] => {
    const yer = (id: string) => { const i = sira.indexOf(id); return i < 0 ? Number.MAX_SAFE_INTEGER : i; };
    return siraNumarala([...liste].sort((a, b) => yer(a.ambarId) - yer(b.ambarId) || a.ambarVoyageOrder - b.ambarVoyageOrder));
}

/** Elle 1. sira isareti yalniz verilen sipariste kalir (null: hicbiri). */
export const ilkSiraIsaretle = <T extends SiraliSiparis>(liste: T[], ambarId: string | null): T[] =>
    liste.map(x => ({ ...x, elleIlkSira: ambarId != null && x.ambarId == ambarId }));

/**
 * ↑: siparisi bir yukari tasir. En uste geldiyse "enUste" true doner — cagiran onu Elle 1. sira yapip kalanlari
 * onizlemeyle dizer; degilse yalniz yer degisir.
 */
export const birYukari = <T extends SiraliSiparis>(liste: T[], ambarId: string): { liste: T[], enUste: boolean } => {
    const i = liste.findIndex(x => x.ambarId == ambarId);

    if (i < 1)
        return { liste, enUste: false };

    const yeni = [...liste];
    [yeni[i - 1], yeni[i]] = [yeni[i], yeni[i - 1]];
    return { liste: siraNumarala(yeni), enUste: i == 1 };
}

/** Elle 1. siradaki siparis (yoksa undefined). */
export const ilkSiradaki = <T extends SiraliSiparis>(liste: T[]): T | undefined => liste.find(x => x.elleIlkSira);

/** "5 sa 07 dk"; bossa "—". */
export const sureMetni = (dk: number | null | undefined) =>
    dk === null || dk === undefined || isNaN(Number(dk)) ? '—' : `${Math.floor(Number(dk) / 60)} sa ${String(Math.round(Number(dk)) % 60).padStart(2, '0')} dk`;
